import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const TrigeminalNeuralgiaPage = () => (
  <>
    <Header />
    <main className="py-12 bg-swastik-lightEarth/40 min-h-screen">
      <div className="container mx-auto px-4 max-w-3xl">
        <h1 className="text-3xl md:text-4xl font-bold text-swastik-blue mb-6">Natural Herbal Treatment for Trigeminal Neuralgia</h1>
        <section className="mb-8">
          <p>Trigeminal Neuralgia is a chronic pain condition affecting the trigeminal nerve in the face. Our natural therapies focus on reducing nerve inflammation, managing pain, and improving quality of life through gentle, effective herbal remedies and lifestyle modifications.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Causes</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Nerve compression</li>
            <li>Multiple sclerosis</li>
            <li>Blood vessel pressure</li>
            <li>Nerve damage</li>
            <li>Age-related changes</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Symptoms</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Severe facial pain</li>
            <li>Sudden pain attacks</li>
            <li>Pain triggered by touch</li>
            <li>Burning sensation</li>
            <li>Pain in jaw or cheek</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Our Herbal Approach</h2>
          <p>We use nerve-calming herbs, anti-inflammatory remedies, and lifestyle modifications to naturally treat trigeminal neuralgia. Our approach focuses on reducing nerve sensitivity, managing pain, and improving overall well-being through personalized treatment plans.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Benefits of Herbal Treatment</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Natural pain relief</li>
            <li>Reduced nerve sensitivity</li>
            <li>Fewer pain attacks</li>
            <li>Improved quality of life</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Lifestyle Recommendations</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Stress management</li>
            <li>Gentle facial exercises</li>
            <li>Avoid trigger foods</li>
            <li>Maintain good posture</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Frequently Asked Questions</h2>
          <div className="mb-4">
            <strong>Q1: How long does it take to see improvement?</strong>
            <p>A: Many patients notice improvement within 1-2 months of consistent treatment.</p>
          </div>
          <div className="mb-4">
            <strong>Q2: Is this treatment safe for long-term use?</strong>
            <p>A: Yes, our natural remedies are gentle and suitable for long-term management of trigeminal neuralgia.</p>
          </div>
          <div className="mb-4">
            <strong>Q3: Can this treatment prevent pain attacks?</strong>
            <p>A: Yes, our holistic approach helps reduce the frequency and intensity of pain attacks.</p>
          </div>
        </section>
        <section className="mb-8">
          <div className="bg-swastik-blue/10 p-6 rounded-lg text-center">
            <h3 className="text-xl font-semibold mb-2">Find relief from trigeminal neuralgia—book your natural treatment consultation today!</h3>
            <a href="/contact" className="inline-block mt-4 px-6 py-2 bg-swastik-blue text-white rounded hover:bg-swastik-blue/90 transition">Book Consultation</a>
          </div>
        </section>
      </div>
    </main>
    <Footer />
  </>
);

export default TrigeminalNeuralgiaPage; 